import { useEffect, useState } from "react";
import {
	detectAvailableRoles,
	determineCombinedFlow,
	getRecipientType
} from "./flow-detector";
import { getActiveFlow } from "./flow-rules";
import { FlowDirection, TransactionTypes } from "./flow-types";
import { detectPullFlowAvailableRoles, determinePullFlowCombinedFlow } from "./pull-flow-detector";

const useFlowDetection = (
	dataElement,
	currentSelections = {},
	identity = null,
	transactionType = TransactionTypes.PUSH_STORE,
	flowDirection = FlowDirection.PUSH
) => {
	const [flowInfo, setFlowInfo] = useState(null);

	const {
		recipient = null,
		provider = null,
		onBehalfOf = null,
		myPrincipals = null,
	} = currentSelections;

	useEffect(() => {
		if (!dataElement) {
			setFlowInfo(null);
			return;
		}

		// Determine flow direction based on transaction type
		const isPullFlow = flowDirection === FlowDirection.PULL && (transactionType === TransactionTypes.PULL || transactionType === TransactionTypes.PULL_FROM_AGENT);

		const availableRoles = isPullFlow ? detectPullFlowAvailableRoles(dataElement, identity) : detectAvailableRoles(dataElement, identity);
		const combinedFlow = isPullFlow ? determinePullFlowCombinedFlow(availableRoles) : determineCombinedFlow(availableRoles);


		const participant = isPullFlow ? provider : recipient; // using the appropriate participant (recipient for PUSH, provider for PULL)
		const recipientType = participant ? getRecipientType(participant[0]) : null;

		const selections = {
			recipient: recipient?.[0]
				? { ...recipient[0], type: recipientType }
				: null,
			provider: provider?.[0]
				? { ...provider[0], type: recipientType }
				: null,
			onBehalfOf: onBehalfOf?.[0] || null,
			myPrincipals: myPrincipals || null,
		};

		// Calculate active flow
		const activeFlow = getActiveFlow(
			combinedFlow,
			selections,
			identity,
			transactionType,
			flowDirection
		);

		setFlowInfo({
			availableRoles, // Available roles
			combinedFlow, // Combined flow
			activeFlow // Currently active flow
		});
	}, [dataElement, provider, recipient, onBehalfOf, myPrincipals, identity, transactionType]);
	return flowInfo;
};

export default useFlowDetection;
